/**
 * Which routes take the whole window.
 *
 * The flow diagram only. `/{sport}/scoring` is an ordinary list page and keeps
 * the menu; `/{sport}/scoring/{id}` is a canvas with its own header, rail and
 * status bar, and would be a second chrome inside the first. Named pages under
 * `/scoring/` — the UI registry — are ordinary pages, not the builder.
 *
 * `/workflows/{code}` is the same canvas for any workflow; the list at
 * `/workflows` keeps the menu.
 */
export function isWorkspace(path: string): boolean {
  return (
    /^\/[^/]+\/scoring\/(?!uis(?:\/|$))[^/]+/.test(path) || /^\/workflows\/[^/]+\/?$/.test(path)
  );
}
